import moment from 'moment'

const getMonthsBetween = (startMonth, startYear, endMonth, endYear) => {
    const startDate = moment(`${startYear}-${startMonth}`, 'YYYY-M')
    const endDate = moment(`${endYear}-${endMonth}`, 'YYYY-M')

    return endDate.diff(startDate, 'months')
}

export const getYOE = workExperiences => {
    let moe = 0

    workExperiences.forEach(({employmentType, startMonth, startYear, endMonth, endYear}) => {
        if (employmentType === 'full-time' || employmentType === 'contract') {
            moe += getMonthsBetween(startMonth, startYear, endMonth, endYear)
        }
    })

    return {years: Math.floor(moe/12), months: moe % 12}
}

export const getInternshipCount = workExperiences => {
    let count = 0

    workExperiences.forEach(({employmentType}) => {
        if (employmentType === 'internship') {
            count ++
        }
    })

    return count
}

// (hasItems: [string], allItems: [string]) => {included: [string], exlcuded: [string]}
export const getExcludedAndIncludedItems = (hasItems, allItems) => {
    const included = []
    const excluded = []

    const hasItemsDict = {}
    hasItems.forEach(item => {
        hasItemsDict[item] = 1
    })

    allItems.forEach( item => {
        if (item in hasItemsDict) included.push(item)
        else excluded.push(item)
    })

    included.sort((a, b) => a.localeCompare(b))
    excluded.sort((a, b) => a.localeCompare(b))

    return {included, excluded}
}